// extracted by mini-css-extract-plugin
export var input = "ToggleButton-module--input--eF63S";
export var label = "ToggleButton-module--label--vOsKa";